import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";
import type { Effect } from "../ir";

// Snappy digital reveal. The X-jitter is mechanical and quick — past 350ms
// it stops feeling glitchy and starts feeling broken. We clean up the chroma
// aberration and scanlines well before the end so the final hold is crisp.
export const glitchIn: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    effects: [
      { kind: "glitch" as Effect, intensity: 0.55 },
      { kind: "chromatic_aberration" as Effect, intensity: 0.4 },
      { kind: "scanlines" as Effect, intensity: 0.3 },
      ...ir.effects,
    ].slice(0, 4),
    tracks: [{
      target: ROOT_TARGET,
      easing: "linear",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0,    x: -10, scale: 1.04, filter: "blur(8px)" },
        { t: 0.08, opacity: 0.6,  x:   8, filter: "blur(3px)" },
        { t: 0.16, opacity: 0.35, x:  -5 },
        { t: 0.24, opacity: 0.85, x:   3, filter: "blur(1px)" },
        { t: 0.34, opacity: 1,    x:  -2, scale: 1.02, filter: "blur(0px)" },
        { t: 0.55, opacity: 1,    x:   1, scale: 0.995 },
        { t: 1.00, opacity: 1,    x:   0, scale: 1 },
      ],
    }],
  };
};
